// External imports
import axios from "axios";
import endPoints from "../../_services/endpoints";
import { fetchTasks } from "./taskActions";
import { env } from "../../_services/env";

// Create Redux action for edit
export const GET_EDIT_TASK = "GET_EDIT_TASK";
export const GET_EDIT_TASK_SUCCESS = "GET_EDIT_TASK_SUCCESS";
export const GET_EDIT_TASK_FAILURE = "GET_EDIT_TASK_FAILURE";

export const SET_EDIT_INITIAL_STATE = "SET_EDIT_INITIAL_STATE";
export const setEditInitialState = () => ({
	type: SET_EDIT_INITIAL_STATE,
});

// Create Redux action creators that return an action for Edit Task
export const getEditTask = () => ({
	type: GET_EDIT_TASK,
});

export const getEditTaskSuccess = (task) => ({
	type: GET_EDIT_TASK_SUCCESS,
	payload: task,
});

export const getEditTaskFailure = () => ({
	type: GET_EDIT_TASK_FAILURE,
});

// editTask
export function fetchEditTask(id) {
	return async (dispatch) => {
		dispatch(getEditTask());

		// alert(id)
		try {
			const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
			if (loggedInUserData) {
				if (loggedInUserData.Token) {
					axios.defaults.headers["ApplicationSecurityCode"] =
						loggedInUserData.ApplicationSecurityCode;
					axios.defaults.headers.common["SECURIT_IDENTITY"] =
						loggedInUserData.Token;
				}
			}
			const response = await axios.get(endPoints.editTask + id);
			const data = await response.data;
			data["communicationConfig"] = {};
			if (data && data.FileSourceTypeId === 2) {
				await axios
					.get(endPoints.editCommunicationCategory + id)
					.then((communicationConfigRes) => {
						data["communicationConfig"] = communicationConfigRes.data;
					})
					.catch((err) => {
						dispatch(getEditTaskFailure());
					});
			}

			if (data.EveryXminutes === 0) {
				data.EveryXminutes = "";
			}

			await dispatch(getEditTaskSuccess(data));
		} catch (error) {
			dispatch(getEditTaskFailure());
		}
	};
}

// editTask
export const CANCEL_EDIT_TASK = "CANCEL_EDIT_TASK";
export const cancelEditTask = () => ({
	type: CANCEL_EDIT_TASK,
});
export function cancelEditingTask() {
	return async (dispatch) => {
		dispatch(cancelEditTask());
	};
}

// Create Redux action for edit
export const UPDATE_TASK_INIT = "UPDATE_TASK_INIT";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAILURE = "UPDATE_TASK_FAILURE";
export const UPDATE_CONTINUE_TASK_SUCCESS = "UPDATE_CONTINUE_TASK_SUCCESS";
// Create Redux action creators that return an action for Edit Task
export const updateTaskInit = () => ({
	type: UPDATE_TASK_INIT,
});
// Update task fn
export const updateTaskSuccess = (task) => ({
	type: UPDATE_TASK_SUCCESS,
	payload: task,
});

// Update task fn
export const updateContinueTaskSuccess = (task) => ({
	type: UPDATE_CONTINUE_TASK_SUCCESS,
	payload: task,
});

export const updateTaskFailure = () => ({
	type: UPDATE_TASK_FAILURE,
});

export function updateTask(task) {
	return async (dispatch) => {
		dispatch(updateTaskInit());

		// alert(task.Id)
		let weekObj = {
			Id: task.Id,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			Notify: task.Notify,
			notifyemail: task.NotifyEmail,

			ScheduleTypeId: task.ScheduleTypeId,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,

			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,

			StartDate: task.StartDate,
			EndDate: task.EndDate,

			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,

			// File_Receive_Path: task.OutboundResponsePath,

			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
			IsExcludeHolidays: task.IsExcludeHolidays,
		};

		let obj = {
			Id: task.Id,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			Notify: task.Notify,
			NotifyEmail: task.NotifyEmail,
			ScheduleTypeId: task.ScheduleTypeId,
			EveryXDays: task.EveryXDays,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,
			DayOfMonth: task.DayOfMonth,
			EveryXMonths: task.EveryXMonths,
			MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
			MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
			EveryXMonths2: task.EveryXMonths2,
			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,
			StartDate: task.StartDate,
			EndDate: task.EndDate,
			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
			DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
			EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
			EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
			MonthOfQuarterly: task.MonthOfQuarterly,
			MonthOfQuarterly2: task.MonthOfQuarterly2,
			QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
			QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
			IsExcludeHolidays: task.IsExcludeHolidays,
		};

		let apiObj = {};
		if (task.ScheduleTypeId === 2) {
			apiObj = weekObj;
		} else {
			apiObj = obj;
		}

		// debugger;

		const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
		if (loggedInUserData) {
			if (loggedInUserData.Token) {
				axios.defaults.headers["ApplicationSecurityCode"] =
					loggedInUserData.ApplicationSecurityCode;
				axios.defaults.headers.common["SECURIT_IDENTITY"] =
					loggedInUserData.Token;
			}
		}
		await axios
			.post(endPoints.updateTask, apiObj)
			.then((res) => {
				// alert("Successfully updated")
				dispatch(updateTaskSuccess());
				// dispatch(fetchTasks())
			})
			.catch((error) => {
				dispatch(updateTaskFailure());
			});
	};
}

export function updateContinueTask(task) {
	return async (dispatch) => {
		dispatch(updateTaskInit());

		// alert(task.Id)
		let weekObj = {
			Id: task.Id,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			Notify: task.Notify,
			notifyemail: task.NotifyEmail,
			IsExcludeHolidays: task.IsExcludeHolidays,
			ScheduleTypeId: task.ScheduleTypeId,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,

			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,

			StartDate: task.StartDate,
			EndDate: task.EndDate,

			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,

			// File_Receive_Path: task.OutboundResponsePath,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
		};

		let obj = {
			Id: task.Id,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			Notify: task.Notify,
			NotifyEmail: task.NotifyEmail,
			ScheduleTypeId: task.ScheduleTypeId,
			EveryXDays: task.EveryXDays,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,
			DayOfMonth: task.DayOfMonth,
			EveryXMonths: task.EveryXMonths,
			MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
			MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
			EveryXMonths2: task.EveryXMonths2,
			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,
			StartDate: task.StartDate,
			EndDate: task.EndDate,
			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,
			// File_Receive_Path: task.OutboundResponsePath,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
			DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
			EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
			EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
			MonthOfQuarterly: task.MonthOfQuarterly,
			MonthOfQuarterly2: task.MonthOfQuarterly2,
			QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
			QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
			IsExcludeHolidays: task.IsExcludeHolidays,
		};

		let apiObj = {};
		if (task.ScheduleTypeId === 2) {
			apiObj = weekObj;
		} else {
			apiObj = obj;
		}

		// debugger;

		const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
		if (loggedInUserData) {
			if (loggedInUserData.Token) {
				axios.defaults.headers["ApplicationSecurityCode"] =
					loggedInUserData.ApplicationSecurityCode;
				axios.defaults.headers.common["SECURIT_IDENTITY"] =
					loggedInUserData.Token;
			}
		}
		await axios
			.post(endPoints.updateTask, apiObj)
			.then(async (res) => {
				task["communicationConfig"] = {};
				axios
					.get(endPoints.editCommunicationCategory + task.Id)
					.then((communicationConfigRes) => {
						task["communicationConfig"] = communicationConfigRes.data;
						dispatch(updateContinueTaskSuccess(task));
					})
					.catch((err) => {});
			})
			.catch((error) => {
				dispatch(updateTaskFailure());
			});
	};
}
